import React from "react";
import ConfigurationHeader from "./header";
import Instagram from "./Social/Instagram";
import Facebook from "./Social/Facebook";
import Twitter from "./Social/Twitter";

const Social = () => {



  return (
    <div className="section_main_div">
      <h1 className="section_heading">Configure</h1>
      <ConfigurationHeader />
      
      <Twitter />
      <Instagram />
      <Facebook />
    </div>
  );
};

export default Social;
